import { useState, useEffect } from 'react';
import { settingsService } from '../../../../services/settingsService';

export const useSettingsData = (tenantData, effectiveTenantId, userData, user) => {
    const [uploading, setUploading] = useState(false);
    const [loyaltyDraft, setLoyaltyDraft] = useState([]);
    const [rolesDraft, setRolesDraft] = useState([]);
    const [profileDraft, setProfileDraft] = useState(null);
    const [generalDraft, setGeneralDraft] = useState(null);
    
    const [isSavingLoyalty, setIsSavingLoyalty] = useState(false);
    const [isSavingRoles, setIsSavingRoles] = useState(false);
    const [isSavingProfile, setIsSavingProfile] = useState(false);
    const [isSavingGeneral, setIsSavingGeneral] = useState(false);
    
    const [bannerUploading, setBannerUploading] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        if (tenantData && !isInitialized) {
            const lLevs = tenantData.loyaltyLevels || tenantData.loyalty_levels;
            if (lLevs) setLoyaltyDraft(JSON.parse(JSON.stringify(lLevs)));

            const vRoles = tenantData.visitRoles || tenantData.visit_roles;
            if (vRoles) setRolesDraft(JSON.parse(JSON.stringify(vRoles)));

            const DEFAULT_WORKING_HOURS = [
                { day: 'Pazartesi', open: '08:00', close: '22:00', active: true },
                { day: 'Salı', open: '08:00', close: '22:00', active: true },
                { day: 'Çarşamba', open: '08:00', close: '22:00', active: true },
                { day: 'Perşembe', open: '08:00', close: '22:00', active: true },
                { day: 'Cuma', open: '08:00', close: '22:00', active: true },
                { day: 'Cumartesi', open: '08:00', close: '22:00', active: true },
                { day: 'Pazar', open: '08:00', close: '22:00', active: true }
            ];

            setProfileDraft({
                name: tenantData.name || '',
                slug: tenantData.slug || '',
                industry: tenantData.industry || '',
                phone: tenantData.phone || '',
                socialMedia: tenantData.social_media || tenantData.socialMedia || {},
                workingHours: tenantData.working_hours || tenantData.workingHours || DEFAULT_WORKING_HOURS,
                city: tenantData.city || '',
                district: tenantData.district || '',
                address: tenantData.address || '',
                googleMapsUrl: tenantData.googleMapsUrl || tenantData.google_maps_url || ''
            });

            setGeneralDraft({
                loyaltyRules: JSON.parse(JSON.stringify(tenantData.loyalty_rules || tenantData.loyaltyRules || {}))
            });
            
            setIsInitialized(true);
        }
    }, [tenantData, isInitialized]);

    const handleUpdateField = async (fieldPath, value, logMessage = null) => {
        await settingsService.updateTenantField(effectiveTenantId, fieldPath, value, userData, user, logMessage);
    };

    const handleLogoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !effectiveTenantId) return;
        setUploading(true);
        try {
            await settingsService.uploadLogo(effectiveTenantId, file, userData, user);
        } finally {
            setUploading(false);
        }
    };

    const handleBannerUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !effectiveTenantId) return;
        setBannerUploading(true);
        try {
            await settingsService.uploadBanner(effectiveTenantId, file, userData, user);
        } finally {
            setBannerUploading(false);
        }
    };

    const handleSaveLoyalty = async () => {
        setIsSavingLoyalty(true);
        try {
            await handleUpdateField('loyaltyLevels', loyaltyDraft, 'Updated loyalty tiers structure');
        } finally {
            setIsSavingLoyalty(false);
        }
    };

    const handleSaveRoles = async () => {
        setIsSavingRoles(true);
        try {
            await handleUpdateField('visitRoles', rolesDraft, 'Updated visit frequency roles structure');
        } finally {
            setIsSavingRoles(false);
        }
    };

    const handleSaveProfile = async () => {
        setIsSavingProfile(true);
        try {
            await handleUpdateField('profile', profileDraft, 'Updated business profile information');
        } finally {
            setIsSavingProfile(false);
        }
    };

    const handleSaveGeneral = async () => {
        setIsSavingGeneral(true);
        try {
            await handleUpdateField('loyaltyRules', generalDraft.loyaltyRules, 'Updated general scoring rules');
        } finally {
            setIsSavingGeneral(false);
        }
    };

    const generateApiKey = async () => {
        const newKey = `sk_${Math.random().toString(36).substr(2, 16)}_${Date.now()}`;
        const existingKeys = tenantData.apiKeys || [];
        const updatedKeys = [...existingKeys, { key: newKey, createdAt: new Date().toISOString(), lastUsed: null }];
        await handleUpdateField('apiKeys', updatedKeys, 'Generated new API Key');
        return newKey;
    };

    const deleteApiKey = async (idx) => {
        const newKeys = tenantData.apiKeys.filter((_, i) => i !== idx);
        await handleUpdateField('apiKeys', newKeys, 'Deleted an API Key');
    };

    return {
        uploading, bannerUploading, handleLogoUpload, handleBannerUpload, handleUpdateField,
        loyaltyDraft, setLoyaltyDraft, handleSaveLoyalty, isSavingLoyalty,
        rolesDraft, setRolesDraft, handleSaveRoles, isSavingRoles,
        profileDraft, setProfileDraft, handleSaveProfile, isSavingProfile,
        generalDraft, setGeneralDraft, handleSaveGeneral, isSavingGeneral,
        generateApiKey, deleteApiKey
    };
};